module.exports = __webpack_public_path__ + "img/iconControlFace.ab4c2b3e.svg";